import React from "react";
import Button from "../../../components/common/button/Button";
import { Form, Formik } from "formik";
import Input from "../../../components/common/inputs/Input";
import { postApi } from "../../../services/api/globalApi";
import { successMessage } from "../../../utils/toastify-message/ToastifyMessage";
import Select from "../../../components/common/inputs/Select";
import { totalStudentValidation } from "../../../utils/validation/public-field/totalStudentValidation";

function TotalStudent({ data }) {
  const formHandler = async (values, {}) => {
    const path = "admin/publicFieldsForFrontUis";
    const body = {
      totalStudent: {
        value: values?.value,
        isActive: values?.isActive,
      },
    };
    try {
      await postApi({ path, body });
      successMessage("تعداد دانشجو با موفقیت بروزرسانی شد.");
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="w-full py-4 px-4 border-r border-l">
      <Formik
        enableReinitialize
        initialValues={{
          value: data?.value || "",
          isActive: data?.isActive || false,
        }}
        validationSchema={totalStudentValidation}
        onSubmit={formHandler}
      >
        {(formik) => (
          <Form>
            <div className="grid gap-6 mb-4 md:grid-cols-2">
              <Input
                name="value"
                placeholder="تعداد"
                label="تعداد"
                type="text"
              />

              <Select
                name="isActive"
                value={formik.values["isActive"] ? "true" : "false"}
                onChange={(e) => {
                  formik.setFieldValue("isActive", e.target.value === "true");
                }}
                placeholder="فعال باشه؟"
                label="فعال باشه؟"
              >
                <option value="true">بله</option>
                <option value="false">خیر</option>
              </Select>
            </div>
            <div className="flex flex-col mt-8 gap-y-2">
              <div className="">
                <Button text={"بروزرسانی اطلاعات"} color={"success"} />
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default TotalStudent;
